import React , {Component} from 'react';
import './OrderHistory.css'
import Card from './Card'
import {NavLink} from 'react-router-dom'

export default class OrderHistory extends Component{
  constructor(props){
    super(props)
    this.state = {
     products: [
         { status:'delivered',title : 'Limelight', price: "1290",SKU:'1'},
         { status:'pending',title : 'Limelight', image: "http://cdn.shopify.com/s/files/1/2635/3244/products/U0707-SSH-BLU_1.jpg?v=1552043754", price: "1290",SKU:'2'},
         { status:'canceled',title : 'Limelight', image: "https://d224nth7ac0evy.cloudfront.net/catalog/product/cache/926507dc7f93631a094422215b778fe0/i/p/ipw-18-62-_3_.jpg", price: "1290",SKU:'1'},
         { status:'delivered',title : 'Limelight', image: "https://www.junaidjamshed.com/media/catalog/product/cache/image/e9c3970ab036de70892d86c6d221abfe/j/j/jjpw-a-jps-203-1.jpg", price: "1290",SKU:'1'},
         {status:'delivered',title : 'Limelight', image: "http://cdn.shopify.com/s/files/1/2635/3244/products/U0387-SSH-PNK_1.jpg?v=1551876015", price: "1290",SKU:'1'},
     ],
    }
}
render(){
    return(
        <div className="ordersParent">
        <ol className="order-items">
        <li className="order-item">
            <p>You can track your order here.Start your first order by clicking on product image.</p>
        </li>
        {/* {this.state.products.map(item=>{
            return(
                
                <Card SKU={item.SKU} brandName={item.title} price={item.price} status={item.status}/>
               
        )})} */}
         </ol>
        </div>
    )
}
} 